module.exports = __webpack_public_path__ + "img/logo_16.c0f1e3af.png";